import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Http } from '@angular/http';
import { WindowRefService, ICustomWindow } from './window.service';

@Injectable()

export class DesignService  {

  private _window: ICustomWindow;
  baseUrl;

  constructor(
    private http: Http,
    windowRef: WindowRefService) { 

    // get reference to window
    this._window = windowRef.nativeWindow

    // get html for all themes
    for (var i = 0; i < this.themes.length; i++) {
      this.getThemeData(this.themes[i])
    }

    function isOdd(num) { return num % 2;}

    // handlebars helpers
    this._window.Handlebars.registerHelper('getTextCol', function(index) {

      // either returns "col-lg-4" or "col-lg-4 col-lg-pull-8"
      // image text

      if(isOdd(index))
        return "col-xs-12 col-md-4 col-md-pull-8"
      else
        return "col-xs-12 col-md-4"

    });

    this._window.Handlebars.registerHelper('getImgCol', function(index) {

      // either returns "col-md-8" or "col-md-8 col-md-push-4"
      // image text

      if(isOdd(index))
        return "col-xs-12 col-md-8 col-md-push-4"
      else
        return "col-xs-12 col-md-8"
      
    });
    
  }

  // create designs array
  // this can be offloaded to an api call eventually perhaps?
  themes = [
    {
      'name':'angled',
      'description': 'The design that got me my first job',
      'image': '../assets/demo-angled.jpg',
      'previewImage': '../assets/demo-angled.jpg',
      'previewImageClipped': '../assets/angled-clipped.png',
      'previewImageFull': '../assets/angled-full.png',
      "demoUrl": "https://chippd.github.io/",
      "html": ""
    },
    {
      'name':'minimal - dark',
      'description': 'Keep it simple',
      'image': '../assets/demo-min-dark.jpg',
      'previewImage': '../assets/demo-min-dark.jpg',
      'demoUrl': "https://chippd.github.io/modern/",
      "html": "",
      "options": {
        "forceDarkMode": true
      }
    },
    { 
      'name':'minimal - bright',
      'description': 'Bright version of Minimal-dark. Note - it looks for the \'prefers-color-scheme: dark\' flag on the browser and will switch to dark mode when found',
      'image': '../assets/demo-min-bright.jpg',
      'previewImage': '../assets/demo-min-bright.jpg',
      'demoUrl': "https://chippd.github.io/modern/",
      "html": "",
      "options": {
        "forceDarkMode": false
      }
    },
    {
      'name':'desk',
      'description': 'A minimal horizontal-scrolling site inspired by a Dribbble shot I found',
      'image': '../assets/demo-desk.jpg',
      'previewImage': '../assets/demo-desk.jpg',
      'previewImageClipped': '../assets/desk-clipped.png',
      'previewImageFull': '../assets/desk-full.png',
      'demoUrl': "https://chippd.github.io/deskportfolio/",
      "html": ""
    },
    {
      'name':'poly',
      'description': 'A minimal layout with a mobile-focused CTA in the footer',
      'image': '../assets/demo-poly.jpg',
      'previewImage': '../assets/demo-poly.jpg',
      'previewImageClipped': '../assets/demo-poly.jpg',
      'previewImageFull': '../assets/poly-full.png',
      'demoUrl': "https://chippd.github.io/triangles/",
      "html": ""
    },
    {
      'name':'modern',
      'description': 'A simple layout with the option to personalise with a location photo of where you\'re from',
      'image': '../assets/demo-modern.jpg',
      'previewImage': '../assets/demo-modern.jpg',
      'demoUrl': "https://chippd.github.io/modern/",
      "html": ""
    }
  ];

  buildSite(buildData){
    // build a site based on a user's data
    console.log("Building site:", buildData);

    let template = this._window.Handlebars.compile(buildData.theme.html);

    return template(buildData);
  }

  getThemes(){
  	return this.themes
  }

  getThemeData(theme){

    let baseUrl;
    if(environment.production){
      baseUrl = window.location.origin+"/"
    } else {
      baseUrl = environment.baseUrl
    }
    
    let url = `${baseUrl}/${encodeURI(theme.name)}/index.html`;
    // console.log('theme url:', url);
    
    this.http
      .get(url)
      .subscribe(
        res => {

          // console.log('resp:', res);
          theme.html = res.text();

        },
        err => {
          console.error('error getting html page:', err);

        })
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/designs.service.ts